import { ComissionApi } from "../../../../Shared/Constants/api";

import axiosInstance from "../../../../Shared/Utils/axiosInstance";

import { getComissionUpdatenObject } from "../Data/ComissionWrappers";

export const updateComissionApi = async (data, id) => {
  try {
    let response = await axiosInstance.put(
      `${ComissionApi}/${id}`,
      getComissionUpdatenObject(data)
    );

    return response.data;
  } catch (error) {
    return error.response.data;
    // throw error; // Re-throw error for further Block if needed
  }
};
